// styles
import classnames from 'classnames/bind';
import Button from 'components/Button';
// components
import ClassSelect from 'components/ClassSelect';
import Portal from 'components/Portal';
import Typography from 'components/Typography';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClASSESS_FULL, DASHBOARD_FULL, OVERVIEW_FULL } from 'routes';
// utils
import { setCurrentClassroom } from 'store/actions/classroom';

import styles from './Navbar.module.scss';

const cx = classnames.bind(styles);

const Navbar = ({ title, classroomList = true }) => {
  const { classrooms = [], first_name = '', username } = useSelector(({ user }) => user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClassChange = (data) => {
    localStorage.setItem('class-id', data.id);
    dispatch(setCurrentClassroom(data));
    navigate(OVERVIEW_FULL);
  };

  return (
    <Portal>
      <nav className={cx('navbar')}>
        <div className={cx('wrapper')}>
          <Typography type="h4">{title || `Welcome, ${first_name || username}!`}</Typography>

          {classroomList && (
            <div className={cx('select-wrapper', 'mgr-20')}>
              <Typography className="mgr-15">Currently viewing:</Typography>
              <ClassSelect options={classrooms} onChange={handleClassChange} />
            </div>
          )}

          {classroomList ? (
            <Button variant="outlined" label="MANAGE CLASSES" onClick={() => navigate(ClASSESS_FULL)} />
          ) : (
            <Button variant="outlined" label="BACK TO DASHBOARD" onClick={() => navigate(DASHBOARD_FULL)} />
          )}
        </div>
      </nav>
    </Portal>
  );
};

export default Navbar;
